import * as React from 'react';
import { Property } from '../../../../../api/Property';
import * as moment from 'moment';
import { formatPhoneNumber } from '../../../../../utilities/Utils';

interface Props {
    propertyInfo: Property;
}

const NotLiveSubPage = (props: Props) => (
    <div>
        <h3>Welcome to {props.propertyInfo.name}!</h3>
        <p>Self-guided tours are currently unavailable at this time.</p>
        <p>
            Please check back when tours go live on{' '}
            {moment(props.propertyInfo.goLiveDate).format('MMMM Do')}.
        </p>
        <p>
            If you would like to schedule a tour before{' '}
            {moment(props.propertyInfo.goLiveDate).format('MMMM Do')}, please email us at{' '}
            <a href={'mailto:' + props.propertyInfo.contactEmail}>
                {props.propertyInfo.contactEmail}
            </a>{' '}
            or call us at{' '}
            <a href={'tel:' + props.propertyInfo.contactPhone}>
                {formatPhoneNumber(props.propertyInfo.contactPhone)}
            </a>{' '}
            to schedule an in-person tour.
        </p>
        <p>Thanks for using Tour24!</p>
    </div>
);

export default NotLiveSubPage;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/property/NotLivePage.tsx